module.exports = __webpack_public_path__ + "media/registry_1200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/registry_1200.jpg
// module id = 32
// module chunks = 0